import { render, staticRenderFns } from "./ListadoFavoritosJefatura.vue?vue&type=template&id=2df9ccc1&"
import script from "./ListadoFavoritosJefatura.vue?vue&type=script&lang=js&"
export * from "./ListadoFavoritosJefatura.vue?vue&type=script&lang=js&"
import style0 from "./ListadoFavoritosJefatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
